import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "search-bar" }
const _hoisted_2 = { class: "search-bar__form" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "search-bar__actions" }
const _hoisted_5 = { class: "search-bar__search" }

import { ref, onMounted, watch } from "vue";

import useWebsiteTexts from "@/composables/useWebsiteTexts";
import { getContext } from "@/composables/useSearch";

import SearchIcon from "@/components/icons/SearchIcon.vue";
import CloseIcon from "@/components/icons/CloseIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchBar',
  setup(__props) {

const { websiteText } = useWebsiteTexts();
const { search } = getContext();

const searchQuery = ref("");
const searchInput: any = ref(null);

function clear() {
  searchQuery.value = "";
}

onMounted(() => {
  searchInput.value?.focus();

  watch(
    () => searchQuery.value,
    () => {
      search(searchQuery.value);
    }
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: _unref(websiteText)('header_searchplaceholder').value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
        class: "search-bar__input",
        ref_key: "searchInput",
        ref: searchInput
      }, null, 8, _hoisted_3), [
        [_vModelText, searchQuery.value]
      ]),
      _createElementVNode("div", _hoisted_4, [
        (searchQuery.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "search-bar__clear",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (clear()))
            }, [
              _createVNode(CloseIcon, { class: "search-bar__clear-icon" })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(SearchIcon, { class: "search-bar__search-icon" })
        ])
      ])
    ])
  ]))
}
}

})